var map = {
	"./brandico.json": "bb07",
	"./entypo.json": "fe63",
	"./font-awesome.json": "bf3c",
	"./fontelico.json": "6176",
	"./glyphicons.json": "c047",
	"./iconic-stroke.json": "77b7",
	"./ionicons.json": "1df5",
	"./maki.json": "9885",
	"./openweb.json": "1f3f",
	"./typicons.json": "61175",
	"./vuestic.json": "2e7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "672c";